import { useState } from "react";
import AuthComp from "../component/AuthComp";
import { Form, FormControl, FormLabel, InputGroup, Row, Col, } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { FaMapMarkerAlt } from "react-icons/fa";

import SessionUtil from "../util/SessionUtil";
// import Swal from 'sweetalert2'
import ListGroup from "../component/ListGroup";

const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValid = (phone) => {
    try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch (error) {
        return false;
    }
};
function Profile() {
    const { t } = useTranslation(); // Use t instead of lang
    const user = SessionUtil.getUser();    
    const [validated, setValidated] = useState(false);
    const [firstName, setFirstName] = useState(user.FirstName);
    const [lastName, setLastName] = useState(user.LastName);
    const [email, setEmail] = useState(user.Email);
    const [msgErrorEmail, setMsgErrorEmail] = useState('');
    const [isEmailError, setIsEmailError] = useState(false);
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState(null)
    const [showPassword, setShowPassword] = useState(false);
    const [phone, setPhone] = useState(user.PhoneNumber);
    const [PhoneNumberWithoutDialCode, setPhoneNumberWithoutDialCode] = useState(user.PhoneNumber);
    const [dialCode, setDialCode] = useState(user.AreaCode);
    const [phoneError, setPhoneError] = useState(null);
    const [phoneValid, setPhoneValid] = useState(null);
    const [msgErrorPhoneNumber, setMsgErrorPhoneNumber] = useState('');
    const [address, setAddress] = useState(user.Address);
    const [addressError, setAddressError] = useState(null);
    // const [msgError, setMsgError] = useState('')
    
    const togglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleEmailChange = (e) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const value = e.target.value;
        setEmail(value);
        // Validate email format
        if (!emailRegex.test(value)) {
            if (!value) {
                setMsgErrorEmail(t("Please enter") + ' ' + t('Email')); // Set your error message
            } else {
                setMsgErrorEmail(t("Invalid email format")); // Set your error message
            }
        } else {
            setMsgErrorEmail('');
            setIsEmailError(false)
        }
    };
    
    const handlePhone = (phone, value) => {
        setMsgErrorPhoneNumber('');
        const PhoneNumber = value.inputValue;
        const dialCode = value.country.dialCode;
        setDialCode(dialCode)
        setPhone(phone);
        setPhoneNumberWithoutDialCode(PhoneNumber);
        if (phoneError !== null) {
            setPhoneValid(isPhoneValid(phone))
            setPhoneError(true)
            setValidated(true);
            if (PhoneNumber !== "") {
                setPhoneError(false)
            }
        }
    }
    const validation = () => {
        setValidated(true);
        setPhoneValid(isPhoneValid(phone))
        if (password === '') {
            setPasswordError(false)
        }
        if (address === '') {
            setAddressError(false)
        }
        if (PhoneNumberWithoutDialCode !== '') {
            if (!isPhoneValid(phone)) {
                setPhoneValid(isPhoneValid(phone))
                setPhoneError(false)
            }
        } else {
            setPhoneError(true);
        }
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setValidated(true);
        validation();
    };

    return (
        <>
        <ListGroup/>
        <AuthComp page="profile" arrowBack={false}>
            <Form autoComplete="off" noValidate validated={validated} onSubmit={handleSubmit}>
                {/* firstName */}
                <Row className="mb-3 g-2">
                    <Col xs={12} md={6}>
                        <Form.Group controlId="formGroupFirstName">
                            <FormLabel className="font-SemiBold">{t("FirstName")}</FormLabel>
                            <FormControl type="text" name="FirstName"
                                placeholder={t("Enter") + ' ' + t('FirstName')}
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                {t("Please enter") + ' ' + t('FirstName')}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    {/* lastName */}
                    <Col xs={12} md={6}>
                        <Form.Group controlId="formGroupLastName">
                            <FormLabel className="font-SemiBold">{t("LastName")}</FormLabel>
                            <FormControl type="text" name="LastName"
                                placeholder={t("Enter") + ' ' + t('LastName')}
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                required />
                            <Form.Control.Feedback type="invalid">
                                {t("Please enter") + ' ' + t('LastName')}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>
                {/* Email */}
                <Form.Group className="mb-3" controlId="formGroupEmail">
                    <Form.Label className="font-SemiBold">{t("Email")}</Form.Label>
                    <Form.Control
                        type="email"
                        name="Email"
                        autoComplete="off"
                        placeholder={t("Enter") + ' ' + t('Email')}
                        value={email}
                        onChange={handleEmailChange}
                        required
                        isInvalid={isEmailError}
                    // isValid={!msgErrorEmail && email}
                    />
                    <Form.Control.Feedback type={(isEmailError || email === '') ? 'invalid' : 'valid'}>
                        {msgErrorEmail === '' ? !email && t("Please enter") + ' ' + t('Email') : t(msgErrorEmail)}

                    </Form.Control.Feedback>

                </Form.Group>
                { /* password */}
                <Form.Group className="mb-3" controlId="formGroupPassword">
                    <Form.Label className="font-SemiBold">{t("Password")}</Form.Label>
                    <InputGroup>
                        <Form.Control name="Password" autoComplete="new-password"
                            type={showPassword ? 'text' : 'password'}
                            placeholder="**************"
                            value={password}
                            onChange={
                                (e) => {
                                    setPassword(e.target.value);
                                    if (passwordError !== null) e.target.value !== '' ? setPasswordError(true) : setPasswordError(false);
                                }
                            }
                            required />
                        <div
                            className={`btn-input-group ${passwordError === null ? '' : passwordError ? 'border-success' : 'border-danger'}`}
                            onClick={togglePassword}
                        >
                            {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                        </div>
                        <Form.Control.Feedback type="invalid">
                            {t("Please enter password")}
                        </Form.Control.Feedback>
                    </InputGroup>

                </Form.Group>

                {/* phone number */}
                <Form.Group className="mb-3" >
                    <FormLabel className="font-SemiBold">{t("Phone Number")}</FormLabel>
                    <div className="position-relative">
                        <PhoneInput
                            className={`border  ${phoneValid === null ? '' : phoneValid ? 'border-success' : 'border-danger'} `}
                            disableDialCodePrefill={true}
                            disableDialCodeAndPrefix={true}
                            showDisabledDialCodeAndPrefix={true}
                            defaultCountry="jo"
                            value={phone}
                            onChange={handlePhone}
                            inputProps={{
                                name: "phone",
                                placeholder: t("Enter phone number"),
                                required: true,
                                pattern: '^\\+?[1-9]\\d{1,14}$', // validate phone number format
                            }}
                        />
                        <div className={`validation-style ${phoneError === null ? '' : phoneError || !phoneValid ? 'invalid' : 'valid'} `}></div>
                    </div>
                    {phoneError != null && <div className={`invalid-feedback ${!phoneValid && 'd-block'}`}> {msgErrorPhoneNumber === '' ? (phoneError ? t("Please enter phone number") : t("phone number invalid")) : t(msgErrorPhoneNumber)}   </div>}


                </Form.Group>
                {/* address */}
                <Form.Group className="mb-3" controlId="formGroupAddress">
                    <FormLabel className="font-SemiBold">{t("Address")}</FormLabel>
                    <InputGroup>
                        <div className="position-relative w-100">
                            <span className="custome-input-group-text"><FaMapMarkerAlt /></span>
                            <FormControl type="text" name="Address"
                                className="custome-form-control"
                                placeholder={t("3235 Royal Ln. mesa, new jersy 34...")}
                                value={address}
                                onChange={
                                    (e) => {
                                        setAddress(e.target.value);
                                        if (addressError !== null) e.target.value !== '' ? setAddressError(true) : setAddressError(false);
                                    }
                                }
                                required /><Form.Control.Feedback type="invalid">
                                {t("Please enter address")}
                            </Form.Control.Feedback>
                        </div>
                    </InputGroup>
                </Form.Group>
                {/* {msgError !== '' && <Alert variant={'danger'} className="mt-3 py-2">{t(msgError)}</Alert>} */}

            </Form>
        </AuthComp>
        </>
    );
}

export default Profile;
